import { Text } from '@mantine/core';
import { BackButton } from 'components/shared';
import { useNavigate, useParams } from 'react-router';
import { useConnector, useUpdateConnector } from 'utils/connectors';
import { ConnectorForm } from 'components/ConnectorsDashboard/components/ConnectorForm/ConnectorForm';

export const EditConnector = () => {
  const { connectorId } = useParams();
  const { data, loading, error } = useConnector(connectorId);
  const connector = data?.Connector;
  const [updateConnector] = useUpdateConnector();
  const navigate = useNavigate();

  const onUpdate = formValues => {
    const id = connector.id;
    return updateConnector({ variables: { connector: { ...formValues, id } } });
  };

  if (loading) {
    return <Text>Loading...</Text>;
  }

  if (error) {
    return <Text>Failed to load the connector.</Text>;
  }

  return (
    <>
      <BackButton onClick={() => navigate('/connector/list')}>
        {'<'} Back to all Connectors
      </BackButton>
      <ConnectorForm connector={connector} onSubmit={onUpdate} action="UPDATE" />
    </>
  );
};
